import appendQuery from 'append-query'
import { getResults } from '.'
import { CopilotCreateData, CopilotUpdateData, CopilotUploadPreset } from '../types/copilot'
import { DELETE, GET, POST, PUT } from '../util/fetch-methods'

const API_BASE_URL = '/api/v1/dvr-service'
const COPILOT_BASE_URL = '/ajax/copilot/presets/upload'

export const getVideoEmbedInfo = (url: string, withCaption: boolean = false) => {
    const requestUrl = appendQuery(`${API_BASE_URL}/video_info`, {
        url: encodeURIComponent(url),
        withCaption,
    })

    return getResults(requestUrl, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
}

export async function createCopilotPreset(data: CopilotCreateData): Promise<CopilotUploadPreset> {
    return getResults(COPILOT_BASE_URL, POST(data, true)).then(({ upload_preset }) => upload_preset)
}

export async function deleteCopilotPreset(id: string): Promise<Response> {
    return fetch(COPILOT_BASE_URL, DELETE({ preset_id: id }, true))
}

export async function fetchCopilotPresetsById(ids: string[]): Promise<CopilotUploadPreset[]> {
    return getResults(
        appendQuery(COPILOT_BASE_URL, {
            preset_ids: ids.join(','),
        }),
        GET
    ).then(({ upload_presets }) => upload_presets)
}

export async function fetchCopilotPresetsByAuthorId(id: string): Promise<CopilotUploadPreset[]> {
    return getResults(
        appendQuery(COPILOT_BASE_URL, {
            author_id: id,
        }),
        GET
    ).then(({ upload_presets }) => upload_presets)
}

export async function updateCopilotPreset(id: string, data: CopilotUpdateData): Promise<CopilotUploadPreset> {
    return getResults(COPILOT_BASE_URL, PUT({ ...data, preset_id: id }, true)).then(
        ({ upload_preset }) => upload_preset
    )
}
